import { Sparkles, ArrowUpRight, CheckCircle2 } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function SamAI() {
  const features = [
    "AI-Powered Question Solving",
    "Smart Study Notes Generation",
    "Previous Year Questions (PYQ)",
    "Performance Analytics",
    "Personalised Learning Path",
    "NEET, JEE, CET & UPSC Ready",
  ];

  return (
    <div className="pt-24 md:pt-32">
      <section className="relative overflow-hidden" style={{ background: "#F5F2ED" }}>
        <div className="noise" />
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 relative">
          <div className="grid lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-6">
              <Reveal>
                <span className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.24em] text-neutral-600">
                  <span className="inline-block w-6 h-px bg-neutral-500" />
                  Sconti.AI Presents
                </span>
                <div className="mt-6 flex items-baseline gap-3">
                  <span className="font-serif text-7xl md:text-8xl italic tracking-tight text-neutral-950">
                    ∫amAI
                  </span>
                </div>
                <h1 className="mt-6 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                  AI-powered exam preparation
                </h1>
                <p className="mt-6 text-lg text-neutral-700 leading-relaxed max-w-xl">
                  SamAI is an intelligent exam preparation platform designed to assist students in
                  mastering competitive exams like NEET, CET, JEE, UPSC, and KPSC with real-time AI
                  assistance.
                </p>
                <div className="mt-10 flex flex-wrap gap-3">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.scontinent.sconti&hl=en_IN"
                    target="_blank"
                    rel="noreferrer"
                    className="btn-pill btn-pill--primary"
                    data-testid="samai-page-download"
                  >
                    Download App
                    <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.scontinent.sconti&hl=en_IN"
                    target="_blank"
                    rel="noreferrer"
                    className="btn-pill btn-pill--secondary"
                  >
                    Learn More
                  </a>
                </div>
              </Reveal>
            </div>
            <div className="lg:col-span-6">
              <Reveal delay={200}>
                <div className="rounded-3xl overflow-hidden bg-white border border-neutral-300 p-6 md:p-8">
                  <img
                    src="/assets/samai-product.png"
                    alt="SamAI — AI-powered exam preparation app"
                    className="w-full h-auto object-contain"
                    loading="eager"
                  />
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-white border-t border-neutral-100">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <Reveal key={f} delay={i * 60}>
                <div className="border border-neutral-200 rounded-2xl p-8 h-full hover:border-neutral-900 transition-colors">
                  <div className="w-10 h-10 rounded-full bg-neutral-950 text-white grid place-items-center">
                    <Sparkles className="w-4 h-4" strokeWidth={1.75} />
                  </div>
                  <div className="mt-6 font-serif text-xl tracking-tight leading-snug">{f}</div>
                  <div className="mt-3 flex items-center gap-2 text-xs text-neutral-500">
                    <CheckCircle2 className="w-3.5 h-3.5" strokeWidth={1.75} /> Available in-app
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
